import React from "react"

import {
	Box,
	ToggleButtonGroup,
} from "@mui/material"

import {
	plural,
	Trans,
} from "@lingui/macro"
import { UseFormReturn } from "react-hook-form"

import {
	withUseFormHook,
} from "@sinossi/mates-react-library"

import {
	PageSectionTitle,
	SbToggleButton,
} from "components/commons"
import {
	SearchFilter,
	PaginatedResponse,
	Template,
	Workflow, AssignableUsers,
} from "models"

import WorkflowComponentValidation, { UpdateWorkflowForm } from "./form"
import WorkflowSection from "./workflow-components/workflow-section"
import TemplateSection from "./workflow-components/template-section"

interface WorkflowComponentProps extends UseFormReturn
{
	onSectionChanged: (kind: string|null) => void
	handleTemplatePagination: (request: SearchFilter) => void
	handleWorkflowPagination: (request: SearchFilter) => void
	templatesData: PaginatedResponse<Template>
	workflowsData: PaginatedResponse<Workflow>
	usersData: AssignableUsers[]
	activeSection: string
}
interface WorkflowComponentState
{
}
class WorkflowComponent extends React.Component<WorkflowComponentProps, WorkflowComponentState>
{
	private handleTemplatePagination = (request: SearchFilter) => {
		this.props.handleTemplatePagination(request)
	}

	private handleWorkflowPagination = (request: any) => {
		this.props.handleWorkflowPagination(request)
	}

	private changeSection = (_event: React.MouseEvent<HTMLElement>, section: string | null) => {
		if(section && section !== this.props.activeSection) {
			this.props.onSectionChanged(section)
		}
	}

	render()
	{
		let title: string
		if(this.props.activeSection === "Workflow") {
			title = plural(
				this.props.workflowsData.pagination.totalRecords ?? 0,
				{
					one: "# Workflow impostato",
					other: "# Workflow impostati",
				}
			)
		} else {
			title = plural(
				this.props.templatesData.pagination.totalRecords ?? 0,
				{
					one: "# Template impostato",
					other: "# Template impostati",
				}
			)
		}

		return(
			<Box sx={{mt: 3, bgcolor: "background.default"}} height={"auto"}>
				<PageSectionTitle title={title}>
					<ToggleButtonGroup
						value={this.props.activeSection}
						exclusive
						onChange={this.changeSection}
						aria-label="text alignment"
					>
						<SbToggleButton value="Workflow">
							<Trans id="workflow.workflow">
								Workflow
							</Trans>
						</SbToggleButton>
						<SbToggleButton value="Template">
							<Trans id="workflow.template">
								Template
							</Trans>
						</SbToggleButton>
					</ToggleButtonGroup>
				</PageSectionTitle>

				{this.props.activeSection === "Workflow" &&
					<WorkflowSection
						handlePagination={this.handleWorkflowPagination}
						workflowsData={this.props.workflowsData}
						usersData={this.props.usersData}
					/>
				}
				{this.props.activeSection === "Template" &&
					<TemplateSection
						handlePagination={this.handleTemplatePagination}
						templatesData={this.props.templatesData}
						usersData={this.props.usersData}
					/>
				}
			</Box>
		)
	}
}

export default withUseFormHook<{}>(
	WorkflowComponent,
	WorkflowComponentValidation,
	new UpdateWorkflowForm()
)
